<template>
    <div class="create-account-step">
        <i class="fas fa-house-user"></i>

        <h3>Tell us a bit about your place</h3>
        <h5>This will help tailor your communication with guests</h5>

        <div class="form-account form-create-account">
            <ValidationObserver ref="aboutEstablishmentForm">
                <form v-on:submit.prevent="aboutEstablishment()">
                    <ul>
                        <li v-if="!hostHasEstablishments" class="form-create-account__section">
                            <label for="establishmentName"><h5>Establishment name</h5></label>
                            <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                <input v-model="establishmentName" id="establishmentName" type="text" class="form-account__text">
                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </li>
<!--                                <li class="form-create-account__section">-->
<!--                                    <h5>Why do your guests travel?</h5>-->
<!--                                    <ul class="form-create-account__multiple-choice">-->
<!--                                        <li>-->
<!--                                            <span>Leisure</span>-->
<!--                                            <div class="radio"><div></div></div>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span>Business</span>-->
<!--                                            <div class="radio"><div></div></div>-->
<!--                                        </li>-->
<!--                                        <li class="form-create-account__multiple-choice&#45;&#45;selected">-->
<!--                                            <span>I'm not sure</span>-->
<!--                                            <div class="radio radio&#45;&#45;selected"><div></div></div>-->
<!--                                        </li>-->
<!--                                    </ul>-->
<!--                                </li>-->
                        <li class="form-create-account__section">
                            <h5>What do you call your inventory?</h5>
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <input type="hidden" v-model="inventoryType">
                                <ul class="form-create-account__multiple-choice">
                                    <li v-on:click="setInventoryType('room')" v-bind:class="{'form-create-account__multiple-choice--selected' : inventoryType === 'room'}">
                                        <span>Rooms</span>
                                        <div class="radio" v-bind:class="{'radio--selected' : inventoryType === 'room'}"><div></div></div>
                                    </li>
                                    <li v-on:click="setInventoryType('unit')" v-bind:class="{'form-create-account__multiple-choice--selected' : inventoryType === 'unit'}">
                                        <span>Units</span>
                                        <div class="radio" v-bind:class="{'radio--selected' : inventoryType === 'unit'}"><div></div></div>
                                    </li>
                                    <li v-on:click="setInventoryType('property')" v-bind:class="{'form-create-account__multiple-choice--selected' : inventoryType === 'property'}">
                                        <span>Properties</span>
                                        <div class="radio" v-bind:class="{'radio--selected' : inventoryType === 'property'}"><div></div></div>
                                    </li>
                                </ul>
                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </li>
                        <li class="form-create-account__section">
                            <h5>When communicating with your guests, do you use your {{providerName}} room name or room type name?</h5>
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <input type="hidden" v-model="useRoomNames">
                                <ul class="form-create-account__multiple-choice">
                                    <li v-on:click="setUseRoomName(true)" v-bind:class="{'form-create-account__multiple-choice--selected' : useRoomNames === true}">
                                        <span>Room name (e.g. Room 1)</span>
                                        <div class="radio" v-bind:class="{'radio--selected' : useRoomNames === true }"><div></div></div>
                                    </li>
                                    <li v-on:click="setUseRoomName(false)" v-bind:class="{'form-create-account__multiple-choice--selected' : useRoomNames === false}">
                                        <span>Room type name (e.g. Double room)</span>
                                        <div class="radio" v-bind:class="{'radio--selected' : useRoomNames === false }"><div></div></div>
                                    </li>
                                </ul>
                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </li>
                    </ul>

                    <div v-show="waiting">
                        <Spinner/>
                    </div>

                    <div v-show="!waiting" >
                        <button class="btn btn-primary">Next</button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import { store, mutations } from '@/store.js'

    import Spinner from '../Spinner.vue'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    export default {
        name: "Step3AboutEstablishment.vue",
        components: { Spinner, ValidationObserver, ValidationProvider },
        data: function () {
            return {
                establishmentName: "",
                inventoryType: "",
                useRoomNames: null,
                waiting: false,
                error: null,
            }
        },
        computed: {
            hostHasEstablishments: function() {
                return store.host.establishments && store.host.establishments.length > 0;
            },
            providerName: function () {
                if (store.host.establishments.length > 0 && store.host.establishments[0].provider) {
                    return store.host.establishments[0].provider.name;
                }
                return '';
            }
        },
        methods: {
            setInventoryType: function(inventoryType) {
                this.inventoryType = inventoryType;
            },
            setUseRoomName: function(useRoomNames) {
                this.useRoomNames = useRoomNames;
            },
            aboutEstablishment: function () {
                this.$refs.aboutEstablishmentForm.validate().then(success => {
                    if (!success) {
                        return
                    }
                    this.waiting = true;
                    this.error = null;
                    const body = {
                        inventoryType: this.inventoryType,
                        useRoomNames: this.useRoomNames
                    };
                    if (!this.hostHasEstablishments) {
                        body.name = this.establishmentName;
                    }

                    this.$http.post('/guest-management/v1/users/' + store.host.reference + '/about-establishment', body
                    ).then(response => {
                        this.waiting = false;
                        mutations.setHost(response.data);
                        this.$root.$emit("create-account-about-establishment");
                    }).catch(error => {
                        this.waiting = false;
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    })
                });
            },
        },
        mounted () {
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/pages/create-account";
</style>